/**
 * ``/workspace/templates`` index — v1-style grid surface.
 *
 * Renders ``<TemplatesList>`` (4-col grid w/ thumbnails) and lets the user
 * click into the single-template editor at ``/workspace/templates/edit/$slug``.
 *
 * Why no longer a redirect: the previous ``redirect()`` to ``$kind`` hid the
 * cross-kind browse experience that the v1 settings page offered. We keep
 * the kind-tabbed StudioDrawer split editor under ``$kind`` for the
 * "deep edit one kind at a time" flow; this index surfaces every template
 * across every kind so the user can compare visual / voice options
 * side-by-side before drilling in.
 *
 * Search params: inherited from the parent's ``validateWorkspaceSearch``
 * (declared on ``route.tsx``).
 */

import { createFileRoute } from "@tanstack/react-router";

import { TemplatesList } from "@/features/templates";

export const Route = createFileRoute("/_authed/workspace/templates/")({
  component: TemplatesIndex,
});

function TemplatesIndex() {
  return <TemplatesList />;
}
